import React from "react";
import { FormGroup, Label } from "reactstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import InputError from "components/framework/errorHandling/InputError";
import Select, { MultiValue } from "react-select";
import { InputActionMeta } from "react-select";

export type MultiSelectFormInputProps = {
  disabled?: boolean;
  required?: boolean;
  labelTranslationId?: string;
  labelClassName?: string;
  value?: any;  // adapt to your multi-select value type
  errorHandler?: any; // error handling type you use
  className?: string;
  handleInputChange: (value: any) => void;
  options: any[];
  placeholder?: string;
};

export default function MultiSelectFormInput(props: MultiSelectFormInputProps) {
  const errors = props.errorHandler?.getErrors();

  return (
    <FormGroup className={classNames("mb-2", props.className)}>
      {props.labelTranslationId && (
        <Label className={classNames("form-control-label", props.labelClassName, { "pc-required-label": props.required })}>
          <FormattedMessage id={props.labelTranslationId} />
        </Label>
      )}
      <Select
        isMulti
        options={props.options}
        value={props.value}
        onChange={props.handleInputChange}
        placeholder={props.placeholder}
        isDisabled={props.disabled}
        inputValue={""}
        onInputChange={() => {}}
        onMenuOpen={() => {}}
        onMenuClose={() => {}}
    />
      {errors && <InputError errors={errors} />}
    </FormGroup>
  );
}
